export default [
    'floor-heating',
    'floor-plan',
    'cast',
    'padlock-2',
    'padlock-open-2',
];
